import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuickHealthAssessmentModel } from 'src/app/shared/model/quick.health.assessment';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-ia-step-0',
  templateUrl: './ia-step-0.component.html',
  styleUrl: './ia-step-0.component.css'
})
export class IaStep0Component {

  constructor(
    private userService: UserService,    
    public router: Router,
  ) {}


  _startNewAssessment() {
    const assessment = new QuickHealthAssessmentModel();
    this.userService.createQuickHealthAssessment(assessment).subscribe({
      next: (value) => {
        if(value) {
          this.router.navigateByUrl("/intro-assessment/1/" + value.id)
        }
      }
    })
  }

}
